







import { Component, Vue, Prop } from "vue-property-decorator";
import { routeItems, RouteItem } from "@/router";

@Component({})
export default class TopNav extends Vue {
  get getRoutes() {
    return routeItems.filter(r => r.showOnNav);
  }

  get activeRoute() {
    return this.getRoutes
      .findIndex(r => r.name === this.$route.name)
      .toString();
  }

  public changeRoute(item: RouteItem) {
    if (item.name === "ByPostcode") {
      // Route to ByPostcode manually so optional param doesn't show in url
      this.$router.push(`/ByPostcode`);
    } else {
      this.$router.push(item.path);
    }
  }
}
